import Template from "../../../../components/EmailBlast/Template";

export default function TemplatePage() {
  return <Template />;
}
